module.exports = __webpack_public_path__ + "static/img/top_bg_pc.5e102bf7.png";